import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Stack, Typography } from '@mui/material';

/**
 * Celda de la columna PLAN en la lista de clientes. Active Plus es ADITIVO (no vive en el plan
 * principal): si el cliente lo tiene, se muestra un chip dorado "Active Plus" junto al nombre del
 * plan principal (o solo el chip cuando Active Plus es el único plan). Mantiene el plan visible
 * siempre, ya que se promociona como un plan.
 */
function PlanCell({ data }) {
  const { plan, is_active_plus: isActivePlus } = data;

  if (!plan && !isActivePlus) {
    return <Typography>-</Typography>;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
      {plan ? <Typography>{plan}</Typography> : null}
      {isActivePlus ? (
        <Chip
          label="Active Plus"
          size="small"
          sx={{ bgcolor: 'gold.soft', color: 'gold.main', fontWeight: 700 }}
        />
      ) : null}
    </Stack>
  );
}

PlanCell.propTypes = {
  data: PropTypes.object.isRequired
};

export default PlanCell;
